import { computed, getCurrentInstance, Ref } from "@vue/composition-api";
import { StateRoot } from "@/store/state";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import { AudioFileData, GlobalAudioPlayerData } from "@/components/GlobalAudioPlayer/types";

export default function useGlobalAudioControllerHelper(fileList: Ref<AudioFileData[]>) {
  const vm = getCurrentInstance();
  const state = computed(() => (vm ? (vm.$store.state as StateRoot).globalPlayer : null));

  const play = (uuid: string) => {
    emitter.emit<GlobalAudioPlayerData>(EVENTS.AUDIO_PLAYER_INIT, { fileList: fileList.value, activeUuid: uuid });
  };

  return {
    play,
    state,
  };
}
